import React, { useMemo, useState } from "react";
import "./AdminInputModal.css";
import Input from "../reusable-input/Input";
import Button from "../reusable-button/Button";
import CustomSelect, { OptionType } from "../custom-select/Select";

type FieldConfig = {
  label: string;
  name: string;
  placeholder?: string;
  type?: string;
  onlyNumbers?: boolean;
  regex?: RegExp;
  disabled?: boolean;
  fieldType?: "input" | "select";
  options?: OptionType[];
};

type values = {
  displayYear: string;
  years: string;
};

interface AdminInputModelProps {
  title: string;
  isOpen: boolean;
  values: Record<string, string>;
  fields: FieldConfig[];
  btnLoading: boolean;
  errors?: Record<string, any>;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onClose: () => void;
  onSubmit: () => void;
}

const AdminInputModel: React.FC<AdminInputModelProps> = ({
  title,
  isOpen,
  values,
  fields,
  errors,
  btnLoading,
  onChange,
  onClose,
  onSubmit,
}) => {
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onSubmit();
  };

  let allValuesPresent = useMemo(() => {
    return Object.keys(values).every((item) => values[item].length > 0);
  }, [values]);

  if (!isOpen) return null;

  return (
    <div className="admin-modal-overlay">
      <div className="admin-modal">
        <div className="admin-modal-header">
          <h2>{title}</h2>
          <button className="admin-close-btn" onClick={onClose} type="button">
            ×
          </button>
        </div>

        <form onSubmit={handleSubmit} className="admin-modal-body">
          {fields.map((field) => (
            <div className="admin-form-group" key={field.name}>
              {field.fieldType === "select" ? (
                <CustomSelect
                  label={field.label}
                  placeholder={field.placeholder}
                  name={field.name}
                  options={field.options ?? []}
                  defaultValue={values?.[field.name] || ""}
                  onChange={onChange}
                  disabled={field.disabled}
                  error={errors?.[field.name]}
                />
              ) : (
                <Input
                  label={field.label}
                  type={field.type || "text"}
                  placeholder={field.placeholder}
                  name={field.name}
                  value={values?.[field.name] || ""}
                  onChange={(e) => {
                    if (field.onlyNumbers) {
                      const regex = /^[0-9]*$/;
                      if (!regex.test(e.target.value)) return;
                    } else if (
                      field?.regex &&
                      !field.regex.test(e.target.value)
                    )
                      return;
                    onChange(e);
                  }}
                  disabled={field.disabled}
                  error={errors?.[field.name]}
                />
              )}
            </div>
          ))}
          <div className="admin-modal-footer">
            <div>
              <Button
                text="Cancel"
                classStyle="custom-style"
                type="button"
                onClick={onClose}
              />
            </div>
            <div className="adminModal-create-btn">
              <Button
                text={title?.split(" ")[0] ?? "Create"}
                type="submit"
                disabled={!allValuesPresent}
                loading={btnLoading}
              />
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AdminInputModel;
